// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Linkedin = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Linkedin = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Linkedin = _exports.Linkedin = function Linkedin(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.86723 17.4996H2.7089V8.0246H5.86723V17.4996ZM6.1839 4.34127C6.1839 3.34127 5.39224 2.53293 4.39224 2.49959C3.37557 2.47459 2.52557 3.27459 2.50057 4.29126C2.47557 5.30792 3.27557 6.15793 4.29223 6.18293C5.32557 6.19126 6.16724 5.3746 6.1839 4.34127ZM17.4589 11.7746C17.4589 8.8246 15.5506 7.92459 13.9256 7.92459C12.7839 7.89126 11.7089 8.44959 11.0839 9.39959V8.03293H8.0339V17.5079H11.1922V12.5913C11.1922 12.5413 11.1922 12.4913 11.1922 12.4413C11.1922 12.4413 11.1922 12.4413 11.1922 12.4329C11.1256 11.4246 11.8922 10.5496 12.9006 10.4829C13.7256 10.4829 14.3506 11.0163 14.3506 12.5163V17.5079H17.5089L17.4672 11.7829L17.4589 11.7746Z",
      fill: "currentColor"
    }));
  };
});
